import { useState, useEffect } from "react";
import { Loader2, Download, Receipt } from "lucide-react";
import api from "@/lib/api";
import { money } from "@/lib/landingSim";

const B = process.env.REACT_APP_BACKEND_URL;
const METHOD = { card: "Card", zelle: "Zelle", check: "Check", cash: "Cash", other: "Other" };

export const MyReceiptsTab = () => {
  const [year, setYear] = useState("");
  const [d, setD] = useState(null);
  const [years, setYears] = useState([]);
  useEffect(() => {
    api.get("/api/customer/receipts", { params: year ? { year } : {} })
      .then(r => { setD(r.data); if (!year) setYears(r.data.years); })
      .catch(() => setD(false));
  }, [year]);
  if (d === false) return <p className="text-sm text-slate-500" data-testid="my-receipts-error">Receipts aren't available right now.</p>;
  if (!d) return <Loader2 className="w-6 h-6 animate-spin text-blue-600 mx-auto my-10" />;
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm space-y-4 max-w-3xl" data-testid="my-receipts">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div><h2 className="text-lg font-bold text-slate-900 flex items-center gap-2"><Receipt className="w-5 h-5 text-blue-600" />Receipts</h2><p className="text-sm text-slate-500">Every payment you've made to ShopAdvisor&trade;.</p></div>
        <select value={year} onChange={e => setYear(e.target.value)} className="h-9 border border-slate-200 rounded-md px-2 text-sm" data-testid="my-receipts-year">
          <option value="">All years</option>{years.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>
      <div className="bg-green-50 border border-green-200 rounded-lg p-3 flex items-center justify-between" data-testid="my-receipts-total">
        <p className="text-sm text-green-800">{year ? `Total paid in ${year}` : "Total paid"} · {d.count} payment{d.count === 1 ? "" : "s"}</p>
        <p className="text-xl font-black text-green-700">{money(d.total)}</p>
      </div>
      {d.receipts.length === 0 ? <p className="text-sm text-slate-400 text-center py-6" data-testid="my-receipts-empty">No receipts yet — they'll appear here after each payment.</p> : (
        <div className="divide-y divide-slate-100">{d.receipts.map(r => (
          <div key={r.id} className="flex flex-wrap items-center gap-3 py-3" data-testid={`my-receipt-${r.id}`}>
            <div className="flex-1 min-w-[180px]">
              <p className="font-semibold text-slate-900">{r.description}</p>
              <p className="text-xs text-slate-500">{r.receipt_number} · {r.paid_at.slice(0, 10)} · {METHOD[r.method] || r.method}{r.reference ? ` · ${r.reference}` : ""}{r.business ? ` · ${r.business}` : ""}</p>
            </div>
            <p className="font-bold text-slate-900 w-24 text-right">{money(r.amount)}</p>
            <a href={`${B}/api/public/receipts/${r.id}/pdf`} className="text-sm font-semibold text-blue-600 hover:underline flex items-center gap-1" data-testid={`my-receipt-pdf-${r.id}`}><Download className="w-4 h-4" />PDF</a>
          </div>
        ))}</div>
      )}
    </div>
  );
};
